import styled from 'styled-components';
import '@carvana/showroom-css-theme/Theme.css';

const StatusInfoWrapper = styled.div<{ expired: boolean }>`
  display: flex;
  align-items: center;
  font-weight: 450;
  font-size: 12px;
  line-height: 16px;
  color: ${(props) => props.theme.color.primary.v600};
  font-feature-settings: 'liga' off;
  text-transform: capitalize;
  padding: 4px 10px;
  border-radius: 3px;
  margin: 20px 0 0;
  width: 100%;
  justify-content: center;
  font-feature-settings: 'liga' off;

  ${(props) =>
    props.expired ? 'background: #E03131;' : 'background: #F4F8FA;'};

  /* Tablet and above */
  @media (min-width: 768px) {
    width: unset;
    justify-content: flex-end;
    margin: 0;
  }
`;

const StatusText = styled.div`
  font-weight: 700;
`;

const WarningWrapper = styled.div`
  display: flex;
  color: #fff;
  align-items: center;

  /* Mobile */
  @media (max - width: ${(props) => props.theme.breakpoint.sm}px) {
    align-items: flex - start;
    margin-top: 4px;
  }
`;

export { StatusInfoWrapper, StatusText, WarningWrapper };
